/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class BenefitController {
    public static $inject = [
        'User',
    ];

    public user;

    constructor(private User: IUserService) {
        this.user = User.getCurrentUser();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
}

angular.module('beneple.global')
    .controller('BenefitController', BenefitController);


class BenefitManageInsuranceController {
    public static $inject = [
        '$scope',
        '$http',
        '$state',
        '$uibModal',
        'User',
        'Orgs',
        'upload',
        'bsLoadingOverlayService',
        'toaster',
        'Employee',
        '$rootScope',
    ];

    public user;
    public org;
    public providers;
    public schema;
    public fields;

    public employee;
    public isTour;
    public hasPermission;

    public fileName = <any>{};
    public files = {
        table_of_benefits: undefined,
        network_list: undefined,
        broker_on_record: undefined,
        census_list: undefined,
        claim_report: undefined,
        loss_ratio: undefined
    };
    
    public errors = false;
    public errorsFiles = false;
    private flush_network_list = false;

    public isCurrent = -1;
    public isHelping = false;
    public showOverlayCallOuts = false;

    public addInsuranceProcess = {
        insurance: undefined,
        description: undefined,
        premium: undefined,
        renewal_date: undefined
    };

    public selectedEdorsmentStatusTab: number = 0;

    public endorsementDocRequestType = [
        'Addition',
        'Amendment',
        'Deletion'
    ];

    public newEndorsmentDocGroup = {
        id: 0,
        description: '',
        requestType: '',
        uploadedDate: '',
        status: '',
        statusDate: '',
        notes: '',
        files: [],
        employeeList: [],
    };

    public newEdorsmentDoc = {
        file: '',
        fileUrl: ''
    };

    public newEdorsmentDocEmployees = {
        id: '',
        name: '',
        email: '',
    };

    public employeeListModal = [];

    public fileListModal = [];

    public importVisible = false;

    public endorsmentDocuments = [];

    public endorsementModalType = '';

    public employeeSelectList = [];

    public employeeSelected = '';

    public newUserAdded: boolean = false;

    constructor(private $scope: angular.IScope,
                private $http: ng.IHttpService,
                private $state: angular.ui.IStateService,
                private $uibModal: any,
                private User: IUserService,
                private Org: IOrgsService,
                private upload: any,
                private bsLoadingOverlayService: IBsLoadingService,
                private toaster: toaster.IToasterService,
                private Employee: IEmpService,
                private $rootScope: ng.IRootScopeService,) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;
        bsLoadingOverlayService.start({referenceId: 'loader'});
        this.user = User.getCurrentUser();
        Org.getMyOrg().then((org) => {
            this.org = org;
            this.checkLoading();
            const { extra } = org as any;
            const { endorsementDocuments = [] } = extra as any;
            this.endorsmentDocuments = endorsementDocuments;       
        });

        $http.get('/api/insurance/providers').then((r) => {
            this.providers = r.data;
            this.checkLoading();
        });

        Org.loadSchema().then((r) => {
            this.schema = r.data;
            this.checkLoading();
        });

        $scope.$emit('$pageWithHelpVisited', 7);
        this.loadEmployee();
        this.loadEmployeeList();
    }

    public loadEmployee = () => {
        this. bsLoadingOverlayService.start({referenceId: 'loader'});
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.isTour = this.Employee.getCoTourStatus();
            let hasVisited: Boolean = false;
            this.employee = response;
            let list: Object[] = this.employee.extra.help_boxes_visited;
            for (let i: number = 0; i < list.length; i++) {
                if ( list[i] === 7) {
                    hasVisited = true;
                }                
            }

            if (!hasVisited) {
                this.startCallouts();
            } else if (this.isTour === true) {
                this.startCallouts();
            }
        });
    };

    public loadEmployeeList(): void {
        this. bsLoadingOverlayService.start({referenceId: 'loader'});
        this.employeeSelectList = [];
        this.Employee.list('').then((response: Restangular.IResponse) => {
            const tmpEmployees: any = this.Employee.getObject();
            for (var h: number = 0; h < tmpEmployees.list.length; h++) {
                let employee: any = {
                    id: tmpEmployees.list[h].id,
                    name: tmpEmployees.list[h].displayname,
                    email: tmpEmployees.list[h].user.email
                };

                // list used in the autocomplete dropdown
                this.employeeSelectList.push(employee);
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            }
        });
    };

    public checkLoading(): any {
        if (this.org && this.org.extra) {
            if (typeof(this.org.extra.details) === 'undefined') {
                this.org.extra.details = {};
            }

            if (typeof(this.org.extra.benefits) === 'undefined') {
                this.org.extra.benefits = [];
            }

            if (typeof(this.org.extra.offices) === 'undefined') {
                this.org.extra.offices = [];
            }

            if (typeof(this.org.extra.processes) === 'undefined') {
                this.org.extra.processes = {};
            }
        }

        if (this.user && this.org && this.providers && this.schema) {
            this.setLabelFiles();
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        }
    }

    public saveProviders(): any {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.org.put().then((org) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('success', 'Preferred Insurance Providers Saved');

        }, (response) => {
        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        this.toaster.pop('error', 'There was an error processing your request.');
        });
    }

    public employeeAdd = () => {
        if (this.newUserAdded) {
            this.loadEmployeeList();
            this.newUserAdded = false;
        }
        
    }

    public addEmployee = (args): void => {
        let modal_instance: any = this.$uibModal.open({
            controller: 'EmployeeNewController as D',
            templateUrl: '/static/templates/modals/add_employee_modal.html',
        });
        this.newUserAdded = true;
    };

    public checkIfDocument = (description: any): boolean => { 
        if (description === 'No documents') {
            return false;
        }
        return true;
    };

    public selectEndorsmentStatusTab = (tab: number) => {
        this.selectedEdorsmentStatusTab = tab;
    };

    public changeEndorsementStatus = (document) => {
        const documentGroupID = document.id;
        const documentGroupStatus = document.status;
        const that: any = this;
        that.bsLoadingOverlayService.start({referenceId: 'loader'});
        const endorsementIndex = that.org.extra.endorsementDocuments.findIndex(((doc) => doc.id === documentGroupID))
        that.org.extra.endorsementDocuments[endorsementIndex].status = documentGroupStatus;
        that.sendEndorsementDocEmail(document, 'doc_status_change');
        that.saveEndorsement();
    };

    public checkUploadStatus = (selectedTab: number): string => {
        if (selectedTab === 5) {
            return 'Guide';
        } else if (selectedTab === 6) {
            return 'Templates';
        }
        return 'Uploaded';
    };

    public openEndorsementLoadDocumentsModal = (docGroup: any, type: string) => {
        this.newEndorsmentDocGroup = docGroup;
        const that: any = this;
        that.endorsementModalType = type; 
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', '$http', 'bsLoadingOverlayService', 
                function ($scope: any, $uibModalInstance: any, toaster: any, $http: any, bsLoadingOverlayService: any): any {
                    $scope.C = that;
                    $scope.model = that.newEndorsmentDocGroup;
                    that.fileListModal = that.newEndorsmentDocGroup.files;
                    that.employeeListModal = that.newEndorsmentDocGroup.employeeList;
                    $scope.employeeAddDocument = (employee) => {
                        if ((employee !== undefined && employee !== null) && employee !== '') {
                            that.employeeSelected = '';
                            if (that.newEndorsmentDocGroup.employeeList === undefined) {
                                that.newEndorsmentDocGroup.employeeList = [];
                            }
                            const index = that.newEndorsmentDocGroup.employeeList.findIndex((empl) => empl.id === employee.new.id);
                            if (index === -1) {
                                that.newEndorsmentDocGroup.employeeList.push(employee.new);
                            } else {
                                that.toaster.pop('warning', 'Employee already in list');
                            }
                            that.employeeListModal = that.newEndorsmentDocGroup.employeeList;
                        }
                    };

                    $scope.removeEmployee = (employee) => {
                        const index = that.newEndorsmentDocGroup.employeeList.findIndex((empl) => empl.id === employee.id);
                        that.newEndorsmentDocGroup.employeeList.splice(index, 1);
                        that.employeeListModal = that.newEndorsmentDocGroup.employeeList;
                    };

                    $scope.updateFileData = (file_data) => { 
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        that.upload({
                            url: '/api/uploads/other',
                            method: 'POST',
                            data: {file: file_data}
                        }).then((response) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            that.toaster.pop('success', 'File has been added');
                            if (that.newEndorsmentDocGroup.files === undefined) {
                                that.newEndorsmentDocGroup.files = [];
                            }
                            that.newEndorsmentDocGroup.files.push({
                                id:  Math.floor(Math.random() * 1000),
                                file: file_data.upload.filename,
                                fileUrl: response.data.url,
                            });
                            that.fileListModal = that.newEndorsmentDocGroup.files;
                        }).catch((err) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            that.toaster.pop('error', `Error in adding file, err: ${err}`);
                        });
                    };

                    $scope.deleteDocument = (file) => {
                        const index = that.newEndorsmentDocGroup.files.findIndex((fil) => fil.id === file.id);
                        that.newEndorsmentDocGroup.files.splice(index, 1);
                        that.fileListModal = that.newEndorsmentDocGroup.files;
                    }

                    $scope.postEndorsementDocGroup = () => {
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        if (that.newEndorsmentDocGroup.id === undefined) { 
                            that.newEndorsmentDocGroup.id = Math.floor(Math.random() * 1000);
                            that.newEndorsmentDocGroup.status = that.checkUploadStatus(that.selectedEdorsmentStatusTab);
                            that.newEndorsmentDocGroup.statusDate = new Date().toISOString();
                            that.newEndorsmentDocGroup.uploadedDate = new Date().toISOString();
                        }
                        if (that.org.extra.endorsementDocuments === undefined) {
                            that.org.extra.endorsementDocuments = [];
                            that.org.extra.endorsementDocuments.push(that.newEndorsmentDocGroup);
                        } else {
                            const index = that.org.extra.endorsementDocuments.findIndex((doc) => doc.id === that.newEndorsmentDocGroup.id);
                            const endorsementLength = that.org.extra.endorsementDocuments.length;
                            if(index === -1 && (endorsementLength === 0 || endorsementLength > 0)) {
                                that.org.extra.endorsementDocuments.push(that.newEndorsmentDocGroup);
                            } else {
                                that.org.extra.endorsementDocuments.splice(index, 1);
                                that.org.extra.endorsementDocuments.push(that.newEndorsmentDocGroup);
                            }
                        }
                        that.sendEndorsementDocEmail(that.newEndorsmentDocGroup, 'new_document');
                        that.saveEndorsement();
                    }
            }],

            templateUrl: '/static/templates/modals/endorsement_documents_modal.html'
        });
    };

    public sendEndorsementDocEmail = (documentGroup: any, type: string) => {
        this.$http.post('/api/insurance/sendendorsementemail', { type, documentGroup});
    };

    public deleteEndorsementGroup = (docGroupID: number) => { 
        const that: any = this;
        const endorsementIndex = that.org.extra.endorsementDocuments.findIndex(o => o.id === docGroupID)
        that.org.extra.endorsementDocuments.splice(endorsementIndex, 1);
        that.saveEndorsement();
    };

    public saveEndorsement = () => {
        const that: any = this;
        that.bsLoadingOverlayService.start({referenceId: 'loader'});

        this.org.put().then((org) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            that.endorsmentDocuments = org.extra.endorsementDocuments;
        }, (response) => {
            this.errors = true;
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        }).then(() => {
            if (!this.errors) {
                this.toaster.pop('success', 'Updated Endorsement Documents', '');
            } else {
                this.toaster.pop('error', 'Failed During Updating Endorsement Documents', '');
            }
        });
    }

    public fileChange() {
        this.importVisible = false
    }


    public openGetQuotePopup(insuranceDescription: string): any {
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', '$http', 'bsLoadingOverlayService', 
                function ($scope: any, $uibModalInstance: any, toaster: any, $http: any, bsLoadingOverlayService: any): any {
                    $scope.insuranceDescription = insuranceDescription;
                    $scope.delete = () => {
                        $uibModalInstance.close($scope.model);
                };

                    $scope.getQuote = function(): void {
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        that.$http.post('/api/insurance/get_quote', {insuranceDescription: insuranceDescription}).then((response) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            that.toaster.pop('success', 'Message sent', 'One of our colleagues will contact you shortly');
                            that.$scope.$emit('$EL', 'insurance.quote');
                            $scope.delete();
                        }, (response) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            that.toaster.pop('error', 'Server Error', 'There was an error processing your request. Please try again.');
                            $scope.delete();
                        });
                    };

            }],

            templateUrl: '/static/templates/modals/getQuoteModal.html'
        });
    }

    public doSave(): any {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        if (
            (this.files.table_of_benefits !== null && this.files.table_of_benefits !== undefined) ||
            ((this.files.network_list !== null && this.files.network_list !== undefined) || this.flush_network_list) ||
            (this.files.broker_on_record !== null && this.files.broker_on_record !== undefined) ||
            (this.files.census_list !== null && this.files.census_list !== undefined) ||
            (this.files.claim_report !== null && this.files.claim_report !== undefined) ||
            (this.files.loss_ratio !== null && this.files.loss_ratio !== undefined)
        ) {
            this.errorsFiles = false;

            this.bsLoadingOverlayService.start({referenceId: 'loader'});
            Object.keys(this.files).forEach((key) => {
                if (!this.files[key]) {
                    delete this.files[key];
                }
            });

            this.fields = Object.keys(this.files);
            const results: any = {};

            this.org.extra.medical_insurance = _.get(this.org.extra, 'medical_insurance', {});
            this.org.extra.medical_insurance.files = _.get(this.org.extra, 'medical_insurance.files', {});
            this.org.extra.medical_insurance.files.network_list = _.get(
                this.org.extra, 'medical_insurance.files.network_list', []
            );

            if (!this.fields.length && this.flush_network_list) {
                this.flush_network_list = false;

                this.org.extra.medical_insurance.files.network_list = [];

                this.org.put().then((org) => {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                }, (response) => {
                    this.errors = true;
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                }).then(() => {
                    if (!this.errors) {
                        this.toaster.pop('success', 'Deleted Network List', '');
                    } else {
                        this.toaster.pop('error', 'Failed During Deleting Network List', '');
                    }
                });
            }

            this.fields.map(field => {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                const that: any = this;
                results[field] = '';
                this.upload({
                    url: '/api/uploads/other',
                    method: 'POST',
                    data: {file: this.files[field]}
                }).then(
                    (response) => {
                        results[field] = response.data.url;
                        delete this.files[field];
                        Object.keys(results).forEach((key) => {
                            if (key === 'network_list') {
                                if (results[key]) {
                                    let link: any = results[key];
                                    let name: string = link.split('/').pop();
                                    this.org.extra.medical_insurance.files.network_list.push({file: link, name: name});
                                    delete results[key];
                                }
                            } else {
                                this.org.extra.medical_insurance.files[key] = results[key];
                            }
                        });

                        this.org.put().then(
                            (org) => {
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            }, (error) => {

                                // pull valid org data when upload fails
                                this.org.get().then(
                                    (org) => {
                                        this.org = org;
                                        this.checkLoading();
                                    }
                                );

                                this.errors = true;
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        }).then(() => {
                            if (this.fields[this.fields.length - 1] === field) {
                                if (!this.errors) {
                                    this.toaster.pop('success', 'Documents Saved', '');
                                    this.emitEvent('insurance.doc.edit')
                                } else {
                                    this.toaster.pop('error', 'Failed During Saving Documents', '');
                                }
                            }
                        });
                        this.setLabelFiles();
                    }, (response) => {
                        this.errors = true;
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('error', 'upload failed', '');
                    }
                );
            }, this);
        } else {
            this.errorsFiles = true;
            this.toaster.pop('error', 'Upload at least one file');
        }
    }

    public deleteDocument(document: string): any {
        switch (document) {
            case 'table_of_benefits': {
                angular.element(".table-of-benefits-upload input[type='file']").val(undefined);
                this.org.extra.medical_insurance.files.table_of_benefits = '';
                this.files.table_of_benefits = undefined;
                this.fileName.table_of_benefits = undefined;
                break;
            }
            case 'broker_on_record': {
                angular.element(".broker-on-record-upload input[type='file']").val(undefined);
                this.org.extra.medical_insurance.files.broker_on_record = '';
                this.files.broker_on_record = undefined;
                this.fileName.broker_on_record = undefined;
                break;
            }
            case 'census_list': {
                angular.element(".census-list input[type='file']").val(undefined);
                this.org.extra.medical_insurance.files.census_list = '';
                this.files.census_list = undefined;
                this.fileName.census_list = undefined;
                break;
            }
            case 'claim_report': {
                angular.element(".claim-report input[type='file']").val(undefined);
                this.org.extra.medical_insurance.files.claim_report = '';
                this.files.claim_report = undefined;
                this.fileName.claim_report = undefined;
                break;
            }
            case 'loss_ratio': {
                angular.element(".loss-ratio-upload input[type='file']").val(undefined);
                this.org.extra.medical_insurance.files.loss_ratio = '';
                this.files.loss_ratio = undefined;
                this.fileName.loss_ratio = undefined;
                break;
            }
            default: {
                break;
            }
        }
        this.deleteFile(document);
    }

    // delete Files document benefits     
    public deleteFile(document_type: string): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        document.body.scrollTop = document.documentElement.scrollTop = 0;   
        this.org.put().then((org) => {
        }, (response) => {

            // pull valid org data when upload fails
            this.org.get().then((org) => {
                this.org = org;
                this.checkLoading();
            });

            this.errors = true;
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        }).then((response) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (!this.errors) {
                this.toaster.pop('success', 'Document Deleted', '');
                this.emitEvent('insurance.doc.' + document_type + '.file_delete');
            } else {
                this.toaster.pop('error', 'Failed During Deleting Documents', '');
            }
        });
    }

    public deleteNetworkListDocument(document_index: number): void {
        this.org.extra.medical_insurance.files.network_list.splice(document_index, 1);
        if (!this.org.extra.medical_insurance.files.network_list.length && !this.files.network_list) {
            this.flush_network_list = true;
        }

        this.handlerDeleteDocumentList();
    };

    // handler to delete file in network list
    public handlerDeleteDocumentList(): void {
        angular.element(".network-list-upload input[type='file']").val(undefined);
        this.files.network_list = undefined;
        this.fileName.network_list = undefined;
        this.deleteFile('network_list');
    };

    public sortByRenewaldDate = (insurance: any) => {
        if(insurance === undefined) {
            return;
        }
        return insurance.sort((a, b) => new Date(a.renewal_date).getTime() - new Date(b.renewal_date).getTime());
    };

    public addInsurance(): void {
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.model = that.addInsuranceProcess;
                $scope.add = () => {
                    $uibModalInstance.close($scope.model); 
                };
            }],

            templateUrl: '/static/templates/modals/add_insurance_modal.html'
        });

        modalInstance.result.then((i) => {
            this.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            let add_item: any = {};
            add_item['insurance'] = i.insurance;
            if (i.description !== undefined) {
                add_item['description'] = i.description;
            }

            if (i.premium !== undefined) {
                add_item['premium'] = i.premium.toString();
            }

            if (i.renewal_date !== undefined) {
                add_item['renewal_date'] =  moment(i.renewal_date).format('YYYY-MM-DD');
            }
            
            
            this.org.extra.medical_insurance = _.get(this.org.extra, 'medical_insurance', {});
            this.org.extra.medical_insurance.insurance_contracts = _.get(
                this.org.extra, 'medical_insurance.insurance_contracts', []
            );
            this.org.extra.medical_insurance.insurance_contracts.push(add_item);
            this.org.put().then((org) => {
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                this.toaster.pop('success', 'Insurance Saved', '');
                this.$scope.$emit('$EL', 'insurance.add');
            }, (reponse) => {
                this.toaster.pop('error', 'Error Saving Insurance', '');
            });
        });
    }

    public editInsurance = (insurance: any, index: number): void => {
        insurance.premium = Number(insurance.premium);
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.model = insurance;
                $scope.add = () => {
                    $uibModalInstance.close($scope.model); 
                };
            }],

            templateUrl: '/static/templates/modals/insurance_edit_modal.html'
        });
        modalInstance.result.then((i) => {
            this.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            this.org.extra.medical_insurance.insurance_contracts[index] = i;
            this.org.put().then((org) => {
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                this.toaster.pop('success', 'Insurance Saved', '');
                this.$scope.$emit('$EL', 'insurance.add');
            }, (reponse) => {
                this.toaster.pop('error', 'Error Saving Insurance', '');
            });
        });
    };

    public openDeleteInsurancePopup(index: number): void {
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.model = {};
                $scope.delete = () => {
                    $uibModalInstance.close($scope.model);
                };
            }],
            templateUrl: '/static/templates/modals/delete_insurance_modal.html'
        });

        modalInstance.result.then((i) => {
            that.org.extra.medical_insurance.insurance_contracts.splice(index, 1);
            that.org.put().then(
                (org) => {
                    this.toaster.pop('success', 'Insurance Removed', '');
                    this.$scope.$emit('$EL', 'insurance.delete');
                }, (reponse) => {
                    this.toaster.pop('error', 'Error Removing Insurance', '');
                }
            );
        });
    }

    
    // set filenames for uploaded files after load page
    public setLabelFiles(): void {
        this.fileName.table_of_benefits = (_.has(this.org.extra.medical_insurance, 'files'))
            ? this.parseFileName(this.org.extra.medical_insurance.files.table_of_benefits) : undefined;

        this.fileName.broker_on_record = (_.has(this.org.extra.medical_insurance, 'files'))
            ? this.parseFileName(this.org.extra.medical_insurance.files.broker_on_record) : undefined;

        this.fileName.census_list = (_.has(this.org.extra.medical_insurance, 'files'))
            ? this.parseFileName(this.org.extra.medical_insurance.files.census_list) : undefined;

        this.fileName.claim_report = (_.has(this.org.extra.medical_insurance, 'files'))
            ? this.parseFileName(this.org.extra.medical_insurance.files.claim_report) : undefined;
        
        this.fileName.loss_ratio = (_.has(this.org.extra.medical_insurance, 'files'))
            ? this.parseFileName(this.org.extra.medical_insurance.files.loss_ratio) : undefined;

        this.fileName.network_list = (_.has(this.org.extra.medical_insurance, 'files') &&
            this.org.extra.medical_insurance.files.network_list &&
            this.org.extra.medical_insurance.files.network_list.length !== 0)
            ? this.parseFileName(this.org.extra.medical_insurance.files.network_list[0].file) : undefined;
    }

    public nextCallout (params: any): any {
        if (this.hasPermission(params)) {
        } else if (!this.hasPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;   
        }
    } 

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }

            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public checkRenewalDates(date: string): string {
        const renewalDate = new Date(date);
        const todayDate = new Date()
        const expiryStart = new Date();
        const expireIn60Days = new Date(todayDate.setTime(todayDate.getTime() + (60 * 24 * 60 * 60 * 1000)));
        if (date === undefined || date === '') {
            return 'notification-square-no-date'
        } else if (renewalDate < expiryStart) {
            return 'notification-square'
        } else if (renewalDate > expiryStart && renewalDate <= expireIn60Days) {
            return 'notification-square-orange';
        }
        return 'notification-square-green';
    }


    /**
     * Parse filename from url
     * @param  {string} input [url from service]
     * @return {string}       [filename parsed]
     */
    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(
                input.substring(input.lastIndexOf('/') + 1)
            );
            
        }
    }

    public nextTour(): any {
        this.$state.go('root.employees');
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

}

angular.module('beneple.global')
    .controller('BenefitManageInsuranceController', BenefitManageInsuranceController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/benefit.controller.ts